<div style="display: flex" class="defaultMargins">
  <div>
    <h4>{{ header }}</h4>
  </div>
  <div style="padding-left: 10px">
    <button
      class="fa-solid fa-rotate-right iconButton drop-shadow-less"
      [showLoadingSpinner]="isLoading || storage.getSyncingStatements()"
      (click)="btnCheckForNew_click()"
      title="Check for new statements"
      aria-label="Check for new statements"
    ></button>
  </div>
  @if (storage.getSyncingStatements()) {
    <div style="padding-left: 10px">
      <p>Syncing statements...</p>
    </div>
  }
</div>

<div
  class="sectionContainer containerMargins"
  [hidden]="!this.statements || this.statements.length == 0"
>
  <table class="selectableTable">
    <tr>
      <th style="width: 60px"></th>
      <th>Type</th>
      <th>Date</th>
      <th>MID</th>
    </tr>
    @for (statement of statements; track statement; let idx = $index) {
      <tr>
        <td>
          <button
            class="fa-regular fa-file-pdf iconButton drop-shadow-less"
            (click)="
              download_click(
                statement.mid,
                statement.hash,
                statement.merchantId
              )
            "
            title="View statement"
            aria-label="View statement"
          ></button>
        </td>
        <td>{{ statement.type }}</td>
        <td>{{ statement.date }}</td>
        <td>{{ statement.mid }}</td>
      </tr>
    }
  </table>
</div>

<div [hidden]="this.statements && this.statements.length > 0">
  <p>We couldn't find any statements.</p>
</div>
